<template>
  <div>
    <template v-if="checkIfCanGerarDae()">
      <v-alert
        v-if="receitaQuitacao.receitaStatus === 'PAGO'"
        dense
        text
        type="success"
      >
        O parcelamento foi <strong>pago</strong> por meio de quitação antecipada.
      </v-alert>
      <template v-else>
        <v-alert
          dense
          text
          type="info"
        >
          Clique em "<strong>Detalhar Quitação</strong>" para gerar o documento de quitação do parcelamento.
        </v-alert>
        <v-btn
          color="#2997F0"
          class="white--text"
          dark
          dense
          @click="detailReceitaQuitacao(true)"
        >
          <v-icon left dark>description</v-icon>
          Detalhar Quitação
        </v-btn>
      </template>
    </template>

    <v-dialog
      v-model="dialog"
      width="800"
    >
      <v-card>
        <v-toolbar
          color="primary"
          class="text-h6 elevation-0"
          dark
        >
          Detalhes da negociação
        </v-toolbar>
        <v-card-text>
          <section>
            <v-row
              v-if="!loaderSearchDetails"
              class="ma-1"
            >
              <v-col
                class="pa-0"
                cols="12"
                md="12"
              >
                <p
                  class="text-subtitle-1 mt-3 ma-0 pa-0 mb-2 text-end"
                  style="width: 100%"
                >
                  <v-chip
                    dark
                    :color="colorChips[receitaQuitacao.receitaStatus]"
                  >Status: {{ formatStatus(receitaQuitacao.receitaStatus) }}</v-chip>
                </p>
              </v-col>
              <v-col
                class="pa-0"
                cols="12"
                md="12"
              >
                <p
                  class="text-subtitle-1 mt-3 ma-0 pa-0 mb-2"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Contribuinte:</strong>
                  {{ receitaQuitacao.contribuinte?.nomeRazaoSocial || "" }} /
                  {{ receitaQuitacao.contribuinte?.cpfCnpj | cnpjCpfFilter }}
                </p>
              </v-col>
              <v-col
                class="pa-0"
                cols="12"
                md="6"
              >
                <p
                  class="text-decoration text-subtitle-1 ma-0 pa-0"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Receita:</strong>
                  {{ receitaQuitacao.sefazReceita?.descricao || "" }}
                </p>
              </v-col>

              <v-col
                class="pa-0"
                cols="12"
                md="6"
              >
                <p
                  class="text-subtitle-1 text-start ma-0 pa-0 text-justify"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Produto:</strong>
                  {{ receitaQuitacao.sefazProduto?.descricao || "" }}
                </p>
              </v-col>
              <v-col
                class="pa-0"
                cols="12"
                md="6"
              >
                <p
                  class="text-subtitle-1 ma-0 pa-0 text-start"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Competência:</strong>
                  {{ formatDate(receitaQuitacao?.competencia, "MM/YYYY") }}
                </p>
              </v-col>
              <v-col
                class="pa-0"
                cols="12"
                md="6"
              >
                <p
                  class="text-decoration text-subtitle-1 ma-0 pa-0"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Data Cadastro:</strong>
                  {{ formatDate(receitaQuitacao?.dataCadastro, "DD/MM/YYYY") }}
                </p>
              </v-col>
              <v-col
                class="pa-0"
                cols="12"
                md="6"
              >
                <p
                  class="text-subtitle-1 font-weight-medium ma-0 pa-0 text-start"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Data Vencimento:</strong>
                  {{ formatDate(receitaQuitacao?.dataVencimento, "DD/MM/YYYY") }}
                </p>
              </v-col>
              <v-col
                class="pa-0 mt-2"
                cols="12"
                md="12"
              >
                <p
                  class="text-subtitle-1 ma-0 pa-0"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Saldo devedor:</strong>
                  R$ {{ calcValortotal() | monetaryFilter }}
                </p>
              </v-col>
              <v-col
                class="pa-0 pb-2"
                cols="12"
                md="6"
              >
                <p
                  class="text-subtitle-1 ma-0 pa-0"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Desconto:</strong>
                  R$
                  {{ (calcValortotal() - receitaQuitacao?.valorTotal) | monetaryFilter }}
                </p>
              </v-col>
              <v-col
                class="pa-0 mt-2"
                cols="12"
                md="12"
              >
                <p
                  class="text-decoration text-subtitle-1 ma-0 pa-0"
                  style="width: 100%"
                >
                  <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Observação:</strong>
                  {{ receitaQuitacao?.informacaoComplementar || "" }}
                </p>
              </v-col>
              <v-divider class="mt-3 mb-3" />
              <v-col
                class="mt-3"
                cols="12"
                md="12"
                style="border: 0.2px solid gray"
              >
                <p
                  class="ma-0 text-subtitle-1 font-weight-bold text-end"
                  style="width: 100%"
                >
                  Valor a pagar: R$
                  {{ receitaQuitacao?.valorTotal | monetaryFilter }}
                </p>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-flex>
                <v-container
                  fill-height
                  style="height: 350px"
                >
                  <v-row
                    align="center"
                    justify="center"
                    class="text-center"
                  >
                    <v-col
                      cols="12"
                      class="d-flex align-center justify-center"
                    >
                      <section
                        class="d-flex flex-column align-center justify-center"
                        style="background-color: #f5f5f5; width: 180px; height: 180px; border-radius: 10px"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          class="mb-3"
                        />
                        <strong class="mt-5">Gerando Simulação</strong>
                      </section>
                    </v-col>
                  </v-row>
                </v-container>
              </v-flex>
            </v-row>
          </section>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-spacer />
          <v-btn
            v-if="!['PAGO', 'CANCELADO'].includes(receitaQuitacao.receitaStatus)"
            :disabled="isLoadingBtn"
            color="primary"
            text
            :loading="isLoadingBtn"
            @click="baixarDae()"
          >
            BAIXAR DAE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { monetaryFormat, cnpjCpfFormat } from "@/util/filters";
import { RevenueStatusList } from "@/models/financeiro/enum/revenue-status.enum";
import newNegociationService from "@/services/financeiro/new-negociation.service";
import AuthService from "@/services/gessan/auth.service";

export default {
  name: "DetailsQuitacaoDialog",
  props: {
    dadosParcelamento: { type: Object, default: () => ({}) },
    parcelas: { type: Array, default: () => [] },
  },
  filters: {
    monetaryFilter: monetaryFormat,
    cnpjCpfFilter: cnpjCpfFormat,
  },
  data() {
    return {
      dialog: false,
      isLoadingBtn: false,
      receitaQuitacao: [],
      loaderSearchDetails: true,
      colorChips: {
        EM_ABERTO: "primary lighten-1",
        PAGO: "green lighten-1",
        PARCELADO: "grey lighten-1",
        APURACAO: "grey lighten-1",
        JURIDICO: "grey lighten-1",
        DIVIDA_ATIVA: "grey lighten-1",
        CANCELADO: "red lighten-1",
        SUSPENSO: "red lighten-1",
        PRE_PARCELADO: "grey lighten-1",
        PARCELAMENTO_PERDIDO: "grey lighten-1",
        PRE_REPACELADO: "grey lighten-1",
        REPARCELADO: "grey lighten-1",
        REPARCELAMENTO_PERDIDO: "grey lighten-1",
        PRE_REREPARCELADO: "grey lighten-1",
        REREPARCELADO: "grey lighten-1",
        REREPARCELAMENTO_PERDIDO: "grey lighten-1",
      },
    };
  },
  watch: {
    parcelas(newVal) {
      if (this.dadosParcelamento && newVal.some(p => p.receitaStatus === "QUITACAO_ANTECIPADA")) {
        this.receitaQuitacao = [];
        this.detailReceitaQuitacao(false);
      }
    },
    dadosParcelamento(newVal) {
      if (!newVal) {
        this.receitaQuitacao = [];
        this.dialog = false;
      }
    },
  },
  methods: {
    baixarDae() {
      this.isLoadingBtn = true;

      newNegociationService
        .baixarDae(
          this.receitaQuitacao?.contribuinte.cpfCnpj,
          [this.receitaQuitacao?.id.toString()],
          this.receitaQuitacao?.dataVencimento
        )
        .subscribe(
          res => {
            const file = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);

            window.open(fileURL);
            this.isLoadingBtn = false;
            this.dialog = false;
          },
          () => {
            this.isLoadingBtn = false;
            AuthService.globalStore("error", "Não foi possível processar a requisição");
          }
        );
    },
    detailReceitaQuitacao(dialog) {
      this.loaderSearchDetails = true;
      this.dialog = dialog;

      newNegociationService
        .detailsReceitaQuitacao(this.dadosParcelamento.id, this.dadosParcelamento.contribuinte.cpfCnpj)
        .subscribe(
          res => {
            this.receitaQuitacao = res;
            this.loaderSearchDetails = false;
          },
          () => {
            this.dialog = false;
            this.loaderSearchDetails = false;
          }
        );
    },
    formatStatus(status) {
      const found = RevenueStatusList.find(s => s.value == status);

      return found ? found.text : status;
    },
    calcValortotal() {
      const initialValue = 0;

      const valorPrincipal = this.parcelas
        .map(p => (p.receitaStatus == "QUITACAO_ANTECIPADA" ? p.valorTotal : 0))
        .reduce((accumulator, currentValue) => accumulator + currentValue, initialValue)
        .toFixed(2);

      return valorPrincipal;
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    checkIfCanGerarDae() {
      return this.parcelas.some(p => p.receitaStatus == "QUITACAO_ANTECIPADA");
    },
  },
};
</script>
